import { NotificationCode } from "./notification-code";

export class NotificationApprovalType {
  constructor(
    public notificationNotificationApprovalTypeId: number | null,
    public approvalType: NotificationCode | null
  ) {}
}
